import {
    CButton,
    CAncora,
    CMobileMenuToggler
} from './styled'

export default {
    'c-button': CButton,
    'c-ancora': CAncora,
    'c-mobile-menu-toggler': CMobileMenuToggler
}